export default __webpack_public_path__ + "static/media/fac6308ab54eca01b5fa89ff8b717e1b.svg";